import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/impulsando-farmacovigilancia-en-europa-guia-practica-para-pymes-farmaceuticas-biotech")({
  head: () => buildRouteHead("/es/impulsando-farmacovigilancia-en-europa-guia-practica-para-pymes-farmaceuticas-biotech", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/webinars", replace: true });
  },
});
